.detailsContainer {
    display: flex;
}
.detailsDateContainer {
    margin-left: 10px;
}